import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {VacancyItem} from "../types/vacancies";

const VACANCIES_COLLECTION = "679f49790024574575ba"

const databases = new Databases(client);

export const vacanciesService = {

  async create(data: VacancyItem): Promise<VacancyItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        VACANCIES_COLLECTION,
        uuidv4(),
        data
      ) as unknown as VacancyItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: VacancyItem): Promise<VacancyItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        VACANCIES_COLLECTION,
        id,
        correctData
      ) as unknown as VacancyItem;

      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async list(queries: string[] = [], limit: number = 100): Promise<VacancyItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        VACANCIES_COLLECTION,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const list = response.documents.map(doc => doc as unknown as VacancyItem);
      return list;
    } catch (error) {
      throw error;
    }
  },
  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        VACANCIES_COLLECTION,
        id
      );
    } catch (error) {
      throw error;
    }
  },

}